/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import useDataHook from '../../api-helpers/useDataHook/useDataHook.js';
import useTagsResourceConfig from './useTagsResource.js';

var useTagsResource = useDataHook(useTagsResourceConfig);

export { useTagsResource as default };
